<template>
    <div>
        <breadCrumb
            :icon="'fa-user-check'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_consentform`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add Consent Form" @click="onAddForm">
                <span class="fal fa-plus mr-2"></span>
                <span>Consent Form</span>
            </button>
        </div>
        <div>
            <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                <li class="nav-item" v-for="t in tabs" :key="t.id">
                    <a class="nav-link bg-transparent fs-lg fw-400" :class="{ 'active': selectedTab == t.id }" @click="selectedTab = t.id">{{ t.text }}</a>
                </li>
            </ul>
            <div class="px-3 px-sm-5 py-4">
                <div class="tab-content">
                    <ConsentFormView
                        ref="consentFormView"
                        :class="{ 'active': selectedTab == 'form' }"
                        class="tab-pane"
                        @onEditForm="onEditForm"
                        @onDeleteForm="onDeleteForm">
                    </ConsentFormView>
                    <ConsentListView
                        :class="{'active': selectedTab == 'list' }"
                        class="tab-pane">
                    </ConsentListView>
                </div>
            </div>
        </div>
        <ConsentFormForm
            ref="consentFormForm"
            @onItemChange="onItemChange">
        </ConsentFormForm>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import ConsentFormView from './ConsentFormView'
import ConsentListView from './ConsentListView'
import ConsentFormForm from './ConsentForm_Form'

export default {
    name: "consentForm",
    components: {
        ConsentFormView,
        ConsentListView,
        ConsentFormForm,
        BreadCrumb,
    },
    data() {
        let tabs = [
            { id: 'form', text: 'Consent Form' }, 
            { id: 'list', text: 'Consent List' }
        ]

        return {
            filterObj: {},

            tabs: tabs,
            selectedTab: tabs[0].id,

            editToggleModal: true,
            sTitle: '',
        }
    },
    methods: {
        onAddForm() {
            this.$refs['consentFormForm'].showModal()
        },
        onEditForm(item) {
            this.$refs['consentFormForm'].showModal(item)
        },
        onDeleteForm(item) {
            this.$refs['consentFormForm'].showDeleteModal(item.consentID)
        },

        onItemChange() {
            this.$refs['consentFormView'].setItems()
        },
    }
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}
</style>